import { view } from "@/mega-ui/helpers/function"
import { confirmEmailGuard } from "@/helpers/routerHelpers"

export const account = {
    path: '/account',
    name: 'account',
    children: [
        {
            path: 'main',
            name: 'account-main',
            meta: {
                withAuth: true,
            },
            component: () => view('account/AccountMainView')
        },
        {
            path: 'create-account',
            name: 'create-account',
            component: () => view('account/CreateAccountView')
        },
        {
            path: 'confirm-email/:uuid([0-9a-fA-F]{8}\\b-[0-9a-fA-F]{4}\\b-[0-9a-fA-F]{4}\\b-[0-9a-fA-F]{4}\\b-[0-9a-fA-F]{12})/:token',
            name: 'confirm-email',
            beforeEnter: [ confirmEmailGuard ],
            meta: {
                withAuth: false
            },
            component: () => view('login/LoginView')
        },
    ]
}